module.exports = __webpack_public_path__ + "img/clock_in_ed.5e50393a.png";